import React from 'react';
import { connect } from 'react-redux';
import { Header, Button, Segment, Popup } from 'semantic-ui-react';
import cogoToast from 'cogo-toast';
import { getCurrentUser } from '../reducers/usersReducer';
import { getLoggedInUser } from '../selectors';

const mapStateToProps = (state) => ({
  user: getCurrentUser(state),
  authUser: getLoggedInUser(state),
});

const ProfileContainer = ({ user = {}, authUser = {} }) => (
  <section>
    <Header
      as="h2"
      content={`${authUser.name || ''} - ${authUser.email || ''}`}
      subheader={user.userId}
    />
    <Segment.Group horizontal>
      <Segment padded>
        <h3>UI Settings</h3>
        <Popup
          trigger={
            <Button
              className="reset-columns"
              negative
              onClick={() => {
                const preferences =
                  JSON.parse(localStorage.getItem('XTable')) || {};
                delete preferences[user.userId];
                localStorage.setItem('XTable', JSON.stringify(preferences));
                cogoToast.info('Column widths reset.');
              }}
            >
              Reset Column Widths
            </Button>
          }
          header="Reset all column widths?"
          content="Click this button to reset all table columns to their default widths."
          on="hover"
        />
      </Segment>
    </Segment.Group>
  </section>
);

export default connect(mapStateToProps)(ProfileContainer);
